import { Industry } from 'src/app/shared/types/industry.types';
import * as IndustriesActions from '../actions/industries.actions';

const initialState: Industry[] = null;

export function reducer(state = initialState, action: IndustriesActions.Actions): Industry[] {
  switch (action.type) {
    case IndustriesActions.INDUSTRIES_LOAD_SUCCESS:
      return action.payload;
    default:
      return state;
  }
}
